import { Timestamp } from "@angular/fire/firestore";

/**
 * A `Date` for an ISO string, `Date` or Firestore `Timestamp`; `undefined` for
 * an empty or unparsable value. The one coercion the replica stores use for
 * their ordering stamps, so they can never disagree on what "older" means.
 */
export function toValidDate(value: unknown): Date | undefined {
    if (value === null || value === undefined || value === '') return undefined;
    const date = convertToDate(value);
    return date instanceof Date && !isNaN(date.getTime()) ? date : undefined;
}

export function convertToDate(date: any): Date {
    if (typeof date === 'string') {
        return new Date(date)
    } else if (date instanceof Date) {
        return date as Date;
    } else if (date instanceof Timestamp) {
        return (date as any)?.toDate();
    } else {
        return date;
    }
}
